import React, { useState,useEffect  } from "react";
import { Link } from "react-router-dom";
import CurrencyInput from 'react-currency-input-field';


function InvestRealState5({onPropertiesDataDataChange}) {
  document.title = "SimWealth";

  const [formData, setFormData] = useState({
    purchasePrice: 200000,
    monthlyRent: 1900,
    monthlyExpenses: 650,
    appreciationRate: 5,
    inflationRate: 4,
    taxRateOnGainUponSale: 20
  });

  const handleChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    onPropertiesDataDataChange({ formData });
  };

  useEffect(() => {
    onPropertiesDataDataChange({ formData });
  }, [onPropertiesDataDataChange]);

  return (
    <>
      <div className="bg bg-InvestRealState1">
      <div data-aos="fade-right" className="container-fluid row vh-100 w-100">
            <div>
              <Link to={'/choose-a-simulation'} className=" threeDButton btn fw-bold RightBtn ">MainMenu</Link>
            </div>   
            <div className=" col-12 col-sm-12 col-md-8 d-flex justify-content-center align-items-start my-auto text-center">
                <div className="bg-white rounded-border ms-3 p-4 border border-4 border-dark">
                  <p className="pb-5 ">The details of both rental properties, along with other relevant information, <br></br>are shown below.</p>
                  <div className="d-flex justify-content-end align-items-end my-3">
                    <label className="fs-18 me-4">Purchase Price</label>
                    <CurrencyInput
                        id="purchasePrice"
                        name="purchasePrice"
                        className="rounded"
                        placeholder="$Purchase Price"
                        decimalsLimit={2}                    
                        prefix="$"
                        min={0}
                        intlConfig={{ locale: 'en-US', currency: 'GBP' }}
                        title="Must be 0 or positive number"
                        value={formData.purchasePrice}
                        onValueChange={(value, name) => handleChange(value, name)}
                        disabled
                      />
                  </div>
                  <div className="d-flex my-3 justify-content-end align-items-end">
                    <label className="fs-18 me-4">Monthly Rent</label>
                    <CurrencyInput
                        id="monthlyRent"
                        name="monthlyRent"
                        className="rounded"
                        placeholder="$Monthly Rent"
                        decimalsLimit={2}                    
                        prefix="$"
                        min={0}
                        intlConfig={{ locale: 'en-US', currency: 'GBP' }}
                        title="Must be 0 or positive number"
                        value={formData.monthlyRent}
                        onValueChange={(value, name) => handleChange(value, name)}
                        disabled
                      />
                  </div>
                  <div className="d-flex my-3 justify-content-end align-items-end">
                  <label className="fs-18 me-4 text-end">Monthly Expenses w/o Mortgage Payments</label>
                    <CurrencyInput
                        id="monthlyExpenses"
                        name="monthlyExpenses"
                        className="rounded"
                        placeholder="$Monthly Expenses"
                        decimalsLimit={2}                    
                        prefix="$"
                        min={0}
                        intlConfig={{ locale: 'en-US', currency: 'GBP' }}
                        title="Must be 0 or positive number"
                        value={formData.monthlyExpenses}
                        onValueChange={(value, name) => handleChange(value, name)}
                        disabled
                      />                    
                  </div>
                  <div className="d-flex my-3 justify-content-end align-items-end">
                    <label className="fs-18 me-4">Appreciation Rate</label>
                    <CurrencyInput
                      id="appreciationRate"
                      name="appreciationRate"
                      className="rounded"
                      placeholder="Appreciation Rate%"
                      suffix="%"
                      title="Valid range is 0% to 20%"
                      value={formData.appreciationRate}
                      onValueChange={(value, name) => handleChange(value, name)}
                      disabled
                    />
                  </div>
                  <div className="d-flex my-3 justify-content-end align-items-end">
                    <label className="fs-18 me-4">Inflation Rate</label>
                    <CurrencyInput
                      id="inflationRate"
                      name="inflationRate"
                      className="rounded"
                      placeholder="Inflation Rate%"
                      suffix="%"
                      title="Valid range is 0% to 20%"
                      value={formData.inflationRate}
                      onValueChange={(value, name) => handleChange(value, name)}
                      disabled
                    />
                  </div>
                  <div className="d-flex my-3 justify-content-end align-items-end">
                    <label className="fs-18 me-4">Tax Rate on Gain Upon Sale</label>
                    <CurrencyInput
                      id="taxRateOnGainUponSale"
                      name="taxRateOnGainUponSale"
                      className="rounded"
                      placeholder="Tax Rate on Gain Upon Sale%"
                      suffix="%"
                      title="Valid range is 0% to 20%"
                      value={formData.taxRateOnGainUponSale}
                      onValueChange={(value, name) => handleChange(value, name)}
                      disabled
                    />
                  </div>
                  <Link to={'/investing-in-real-estate/sixth-step'} className=" threeDButton btn fw-bold  w-50  ">Continue</Link>
                </div>
            </div>
            
        </div>
      </div>
    </>
  );
}

export default InvestRealState5;
